export default __webpack_public_path__ + "images/a7d22255ce6c3671358fbf42cadd98c3.svg";